const DeleteTrainer = () => import('@/views/Dashboard/TrainerManagement/Delete/DeleteTrainer');
const TrainerManagementAll = () => import('@/views/Dashboard/TrainerManagement/View/TrainerManagementAll');
const TrainerShowItem = () => import('@/views/Dashboard/TrainerManagement/Details/TrainerShowItem');
const TrainersCreate = () => import('@/views/Dashboard/TrainerManagement/Create/TrainersCreate');
const TrainerEdit = () => import('@/views/Dashboard/TrainerManagement/Edit/TrainerEdit');

export default {
  path: '/trainers-enabled',
  component: DeleteTrainer,
  children: [
    {
      path: '/',
      name: 'trainer-management',
      component: TrainerManagementAll,
      meta: { preserveTableState: true },
    },
    {
      path: 'show/:id',
      name: 'trainer-show',
      component: TrainerShowItem,
    },
    {
      path: 'create',
      name: 'trainer-create',
      component: TrainersCreate,
    },
    {
      path: 'delete/:id',
      name: 'trainer-delete',
      component: DeleteTrainer,
    },
    {
      path: 'edit/:id',
      name: 'trainer-edit',
      component: TrainerEdit,
    },
  ],
};
